var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "user-questionnaire-form-container w-100 user-modal-register-view px-2",
      style: _vm.containerStyle,
    },
    [
      [
        _c(
          "div",
          { staticClass: "w-100 mb-4" },
          [
            _c("div", { staticClass: "mb-2 text-center" }, [
              _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
                _vm._v(_vm._s(_vm._f("trans")("Tell us about yourself"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-2 text-center py-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("trans")(
                      "And we'll personalize your experience for %project%!",
                      { "%project%": _vm.projectName }
                    )
                  ) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("DotNavigation"),
            _vm._v(" "),
            _c("div", { staticClass: "text-center py-2 mb-2" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm._f("trans")("What do you use %project% for?", {
                      "%project%": _vm.projectName,
                    })
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.isStatusDone
              ? _c("div", [
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info": _vm.dataValue === "Personal use",
                          "btn btn-white": _vm.dataValue !== "Personal use",
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.dataValue = "Personal use"
                            _vm.goToHowDoYouUseTheProject()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("trans")("Personal use")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info":
                            _vm.dataValue === "At work where I am employed",
                          "btn btn-white":
                            _vm.dataValue !== "At work where I am employed",
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.dataValue = "At work where I am employed"
                            _vm.goToHowDoYouUseTheProject()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("trans")("At work where I am employed")
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-5" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow",
                        class: {
                          "btn, btn-info": _vm.dataValue === "My own business",
                          "btn btn-white": _vm.dataValue !== "My own business",
                        },
                        attrs: { disabled: _vm.isSubmitting },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.dataValue = "My own business"
                            _vm.goToHowDoYouUseTheProject()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("trans")("My own business")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div"),
                ])
              : _vm.isStatusLoading
              ? _c("LoadingAnimation", {
                  attrs: { "animation-style": "bars", classes: "mb-4" },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }